import CRUDService from "../../services/base/CRUDService";

export default class NodeService extends CRUDService {

  static ALL_URL = 'cloud/v1/nodes/';

  getBaseURL() {
    return NodeService.ALL_URL;
  }

  save(entity) {
    if (entity.node.id) {
      if (entity.node.type === 'EVEN_READER') {
        return this.httpRequest.put(`cloud/v2/nodes/${entity.node.id}`, entity);
      } else {
        return this.httpRequest.put(`cloud/v1/nodes/${entity.node.id}`, entity.node);
      }
    } else {
      return this.httpRequest.post(this.getBaseURL(), entity);
    }
  }

  findByIdV2(id) {
    return this.httpRequest.get('cloud/v2/node/' + id);
  }

  resetNode(id) {
    return this.getHttpRequest().post(`${this.getBaseURL()}${id}/reset-node`)
  }
}



// WEBPACK FOOTER //
// ./src/gateways/node/NodeService.js